module.exports = __webpack_public_path__ + "img/aics-logo.07ca8fdc.jpg";